export const Footer = () => {
    return (
        <p className="text-center">Copyright braceandbracket &copy; 2023</p>
    )
}